import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from './store';
import { apiString as API_URL } from '../utils/constants';
import axios from 'axios';

const trueBalanceSlice = createSlice({
    name: 'trueBalance',
    initialState: {
        isCloning: false,
    },
    reducers: {
        _toggleIsCloning(state, action) {
            state.isCloning = action.payload;
        },
    },
});

const { _toggleIsCloning } = trueBalanceSlice.actions;

export const cloneMember =
    (memberId: string, callBack: Function = null): AppThunk =>
    (dispatch, getState) => {
        dispatch(_toggleIsCloning(true));
        axios
            .put(`${API_URL}/truebalance/CloneMember/${memberId}`)
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            })
            .finally(() => {
                dispatch(_toggleIsCloning(false));
            });
    };

export default trueBalanceSlice.reducer;
